import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, Input } from 'reactstrap';
import { db } from '../../firebase/firebase';


class NoResults extends Component {
  constructor(props){
    super(props);
    this.state = {
      showTextarea: true,
      showMSG: false,
      text: '',
      mail: ''
    };
  }

  handleChange = (e) => {
    e.preventDefault();
    this.setState({[e.target.name]: e.target.value});
  }

  handleSubmit = () => {
    if(this.state.text !== ''){
      const newDate = new Date();
      var newFeedbackRef = db.ref('feedback').push();
      newFeedbackRef.set({
        user: this.state.mail,
        text: this.state.text,
        timestamp: newDate.toISOString(),
        parameter: {
          path: this.props.path,
          query: this.props.query,
          type: 'no-results'
        }
      });

      this.setState({
        showTextarea: false,
        text: '',
        showMSG: true
      });

    }
  }
  render() {
    return (
      <div className="bg-white border p-3 text-muted text-center">
        <h1 className="text-light mb-4"><i className="fas fa-exclamation-triangle"></i></h1>
        <p className="h5 text-body mb-0">Leider haben wir keine Ergebnisse für <strong className="text-secondary">{this.props.query}</strong></p>
        { this.state.showTextarea &&
          <React.Fragment>
            <p className="mt-5">Gib uns Feedback darüber was dir fehlt.</p>
            <Input type="email" name="mail" className="border mb-2 rounded" value={ this.state.email }  onChange={ this.handleChange } placeholder="E-Mail für Rückfragen (optional)" />
            <Input type="textarea" name="text" className="border rounded pt-2 mb-2 d-block" style={{resize: 'none'}} value={ this.state.text } onChange={ this.handleChange } placeholder="Was fehlt?" />
            <Button color="primary" block onClick={ this.handleSubmit }><i className="fas fa-envelope mr-2"></i>Feedback senden</Button>
          </React.Fragment>
        }
        { this.state.showMSG &&
          <p className="mt-5 text-primary font-weight-bold">Danke für dein Feedback!</p>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  path: props.location.pathname,
  query: state.query
});

export default withRouter(connect(mapStateToProps)(NoResults));



// WEBPACK FOOTER //
// ./src/components/ui-elements/NoResults.js